import React, { useState, useEffect, useMemo } from 'react';
import styled from 'styled-components';
import dayjs, { ManipulateType } from 'dayjs';
import { Flex } from '~/shared/components';
import { ReactComponent as Calendar } from '~/shared/assets/Calendar.svg';
import { DisplayDateResolutionProps } from '../types';

const Wrapper = styled(Flex)<{ display: number }>`
  align-items: center;
  margin-left: 4px;
  cursor: pointer;
  opacity: ${({ display }) => display};
`;

const DateValue = styled('div')`
  margin: 0 5px;
  font-size: 16px;
  font-weight: 400;
  color: var(--text-color);
  left: 50%;
`;

const StyledCalendar = styled(Calendar)`
  color: var(--icon-color);
  fill: var(--icon-color);
  margin-top: -5px;
`;

const DisplayDateResolution = ({ value, onClick, filters, timeResolution }: DisplayDateResolutionProps) => {
  const options = useMemo(() => {
    if (filters?.find((f: any) => f.id === 'Formation Period'))
      return filters?.find((f: any) => f.id === 'Formation Period')?.options;
    if (filters?.find((f: any) => f.id === 'Time Resolution'))
      return filters?.find((f: any) => f.id === 'Time Resolution')?.options;
  }, [filters]);

  const [fromDateValue, setFromDateValue] = useState('');

  useEffect(() => {
    setFromDateValue('');
    options?.forEach((d: any) => {
      if (timeResolution === d.id) {
        const count = d.id.replace('Trending ', '').replace(' ', '-').split('-')[0];
        const key = d.id.replace('Trending ', '').replace(' ', '-').split('-')[1]?.toLowerCase() as unknown as
          | ManipulateType
          | undefined;
        setFromDateValue(dayjs(value).subtract(count, key).format('MMM DD YYYY'));
      }
    });
  }, [timeResolution, options]);

  return (
    <Wrapper onClick={onClick} display={fromDateValue ? 1 : 0}>
      <DateValue>{dayjs(value).format('MMM DD YYYY')}</DateValue>
      <StyledCalendar />
    </Wrapper>
  );
};

export default DisplayDateResolution;
